import { Footer } from "@nju/feature-portal-footer";
import { Header, HeaderBackgroundWrapper } from "@nju/feature-sales-header";
import { DispositionsPage } from "@nju/feature-sales-order";
import { salesRoutes } from "@nju/routes";
import { Back, BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function Dispositions() {
  return (
    <LayoutWrapper>
      <HeaderBackgroundWrapper>
        <Header />
      </HeaderBackgroundWrapper>
      <BlockContent grid="wide" tone="gray">
        <ClientSideOnly>
          <Back
            iconColor="accent"
            text="wróć do panelu konsultanta"
            textWeight="bold"
            type="LINK"
            url={salesRoutes.panel.get()}
          />
          <DispositionsPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
